import type { ReactElement } from 'react';
import { yardTalkLine } from '../../../../../shared/yard-handoff.js';
import { GamesTalkHandoff } from './GamesTalkHandoff';

/**
 * Where Ember games' yard hands a person to Ember (2026-10-23 Riley). The
 * link carries which door they pressed and the tag the yard gave their lines;
 * the first line is written from those (shared/yard-handoff.js), and the page
 * is the games' shared one.
 *
 * Since 2026-10-31 (Riley) the `line` door under a person's own line brings
 * their starred words along in the URL fragment (`#say=`): never sent to a
 * server, never logged. They become the draft in the chat's field — the
 * person sends them, or not — and no line is written for them. On to the
 * chat they go by handle, as the homepage's sentence does (say-handoff.ts):
 * the address never holds them.
 */
export function YardTalkHandoff({ search }: { search: URLSearchParams }): ReactElement {
  const say = readSay();
  return (
    <GamesTalkHandoff
      line={say ? '' : yardTalkLine(search.get('yard'), search.get('tag'))}
      draft={say}
      discovery="yard"
    />
  );
}

/** The person's own starred line off the fragment, at most the yard's 280 characters; '' when there is none. */
function readSay(): string {
  if (typeof window === 'undefined') return '';
  const hash = window.location.hash.replace(/^#/, '');
  if (!hash) return '';
  try {
    const say = new URLSearchParams(hash).get('say') || '';
    return say.replace(/\s+/g, ' ').trim().slice(0, 280);
  } catch { return ''; }
}
